import { render, staticRenderFns } from "./AppDownloadPhotoPlus.vue?vue&type=template&id=474e8d24&scoped=true&"
import script from "./AppDownloadPhotoPlus.vue?vue&type=script&lang=js&"
export * from "./AppDownloadPhotoPlus.vue?vue&type=script&lang=js&"
import style0 from "./AppDownloadPhotoPlus.vue?vue&type=style&index=0&id=474e8d24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474e8d24",
  null
  
)

export default component.exports